export const Font = {
  family: `inherit`, //,Ppobjectsans, 'Helvetica Neue', sans-serif;`,
  weight: {
    light: '300',
    regular: '400',
    medium: '500',
    semiBold: '600',
    bold: '700',
    extraBold: '800',
    black: '900',
  },
}

export const cssVariables = /*css*/ `
  :root {
    --dark-blue: #1e007d;
    --dark-blue-30: rgba(30, 0, 125, 0.3);
    --dark-blue-50: rgba(30, 0, 125, 0.5);
    --white: #fff;
    --off-white: #f9f9f9;
    --light-grey: #fff;
  }
`

interface ScreenWidths {
  MOBILE: number
  TABLET: number
  DESKTOP_SMALL: number
  DESKTOP_MEDIUM: number
  DESTKOP_LARGE: number
  ZERO: number
}

export const SCREEN_WIDTHS: ScreenWidths = {
  MOBILE: 570,
  TABLET: 768,
  DESKTOP_SMALL: 960,
  DESKTOP_MEDIUM: 1024,
  DESTKOP_LARGE: 1366,
  ZERO: 0,
}
